import React from 'react';
import './App.css';
import SplashPage from './components/splash/SplashPage';

function App() {
  return (
    <div className="App">
      <SplashPage />
    </div>
  );
}

export default App;
